var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0239 3.97646C18.2866 5.23951 18.2861 7.28691 17.0232 8.54986L9.78431 15.7887C9.64163 15.9314 9.45699 16.0248 9.25743 16.0546L4.99338 16.6919C4.59288 16.7518 4.24858 16.4074 4.30837 16.0069L4.94504 11.7422C4.9749 11.5427 5.06826 11.358 5.2109 11.2153L12.4498 3.97646C13.7128 2.71342 15.7608 2.71342 17.0239 3.97646Z",
    stroke: "#262626",
    strokeWidth: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1982 5.33594L15.6642 9.80188",
    stroke: "#262626",
    strokeWidth: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditSm);
export default __webpack_public_path__ + "static/media/EditSM.8dc0d321e112a8831b6f8b3a68e20d30.svg";
export { ForwardRef as ReactComponent };